import { XStack } from '@/components/ui/layout/layout';
import { Switch } from '@/components/ui/Switch';

import type { ToolPermission } from '@littlebird/integrations';

export interface ToolAskFirstSwitchProps {
  /** The subject phrase for the accessible name, e.g. "Search issues" —
   * becomes "Ask first for {name}". */
  name: string;
  permission: ToolPermission;
  onChange(permission: ToolPermission): void;
  disabled?: boolean;
}

/** The per-tool Ask first switch. ON = `ask` (Littlebird asks before every
 * run); OFF = `allow` (runs without asking). `deny` — still a valid API
 * value set elsewhere — displays as ON: it's a stronger form of "won't run
 * without you". Toggling a `deny` row off always writes a real `allow`. */
export function ToolAskFirstSwitch({
  name,
  permission,
  onChange,
  disabled,
}: ToolAskFirstSwitchProps) {
  const askFirst = permission !== 'allow';
  return (
    <XStack className="shrink-0 items-center gap-1">
      <span className="text-xs text-foreground-muted">Ask first</span>
      <Switch
        checked={askFirst}
        disabled={disabled}
        aria-label={`Ask first for ${name}`}
        onCheckedChange={(checked) => onChange(checked ? 'ask' : 'allow')}
      />
    </XStack>
  );
}
